import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {CurrenciesListFilter} from './CurrenciesListFilter'

const CurrenciesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddCurrencyModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-currency-table-toolbar='base'>
      <CurrenciesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add currency */}
      <button type='button' className='btn btn-primary' onClick={openAddCurrencyModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='CURRENCY.TABLE.CREATECURRENCY' />
      </button>
      {/* end::Add currency */}
    </div>
  )
}

export {CurrenciesListToolbar}
